// or your router
import { Box } from "@mui/material";
import { useMemo, useRef } from "react";

import { YouTubeHelper, YouTubeUrlInfo } from "@/common/helpers/youTube";

import { MarkdownElCommonProps } from "../MarkdownRenderer";

type Props = MarkdownElCommonProps & {
  videoId?: string;
  url?: string;
  urlInfo?: YouTubeUrlInfo;
};

/** <a href="" /> element. */
export function MarkdownIframeElOfYouTubeVideo({ videoId, url, urlInfo }: Props) {
  const urlInfoLocal = useMemo(() => YouTubeHelper.parseUrl(url), [url]);
  const videoIdComputed = videoId || urlInfo?.videoId || urlInfoLocal?.videoId;

  // const [isLoaded, setIsLoaded] = useState(false);
  const iframeRef = useRef<HTMLIFrameElement>(null);

  if (!videoIdComputed) {
    return null;
  }

  return (
    <Box
      ref={iframeRef}
      component='iframe'
      sx={{
        maxWidth: "100%",
        maxHeight: { xxs: "90vh", md: 600, lg: 800, xl: 1000 },
        aspectRatio: "16 / 9",
        border: (th) => `1px solid ${th.palette.divider}`,
        borderRadius: (th) => th.shapeCustom.borderRadiusImage,
      }}
      src={`https://www.youtube.com/embed/${videoIdComputed}?enablejsapi=1`}
      title='YouTube video player.'
      frameBorder='0'
      allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      referrerPolicy='strict-origin-when-cross-origin'
      allowFullScreen
      // onLoad={() => setIsLoaded(true)}
    />
  );
}
